import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as typeMessages from '../../store/typeMessages'
import { Row, Col, Card } from 'antd'

import LinearChartLive from '../../charts/LinearChartLive'
import Indicator from '../../charts/Indicator'
import Heatmap from '../../charts/Heatmap'
import { LoadingChart } from '../../utils/Utils'

class Temperature extends Component {
  render () {
    let { lastUpdate, lastValue, data, populated, title } = this.props
    return (
      <Row type='flex' justify='center' gutter={8} style={{ padding: '10px' }}>
        <Col span={24} align='center' >
          <Card bodyStyle={{ padding: '0' }} style={{ marginBottom: '10px' }}>
            {populated
              ? <LinearChartLive
                unit='&deg;F'
                title={title}
                data={data}
                lastValue={[lastUpdate, lastValue]}
                color='#ffec3d'
                ylabel='fahrenheit'
                type='line' />
              : <LoadingChart />
            }
          </Card>
        </Col>
        <Col md={19} xs={24} align='center' >
          <Card bodyStyle={{ padding: '0' }} style={{ marginBottom: '10px' }}>
            {populated
              ? <Heatmap
                unit='&deg;F'
                title={this.props.title}
                data={data}
                color='#ffec3d'
                ylabel='fahrenheit'
                range={[38, 45]}
                stops={[
                  [0.0, '#002b4c'],
                  [0.4, '#a0d911'],
                  [0.7, '#faad14'],
                  [0.99, '#f5222d']
                ]}
              />
              : <LoadingChart />
            }
          </Card>
        </Col>
        <Col md={5} xs={24}>
          <Card bodyStyle={{ padding: '10px' }} style={{ marginBottom: '10px' }}>
            <Indicator
              value={lastValue}
              type='icon-thermometer'
              title={'temperature'}
              colors={['#002b4c', '#d4b106']}
              threshold={[0, Infinity]}
              background='#fff'
              unit='&deg;F'
            />
          </Card>
        </Col>
      </Row>
    )
  }
}

Temperature.propTypes = {
  title: PropTypes.string,
  lastValue: PropTypes.number,
  lastUpdate: PropTypes.number,
  data: PropTypes.array,
  populated: PropTypes.bool
}

function mapStateToProps (state) {
  let { mochileros } = state.locations
  return {
    lastValue: mochileros.indicators.temperature.lastValue,
    lastUpdate: mochileros.indicators.temperature.lastUpdate,
    populated: mochileros.indicators.temperature.populated,
    data: mochileros.indicators.temperature.data,
    title: `TEMPERATURE MOCHILEROS`
  }
}
function mapDispatchToProps (dispatch) {
  return bindActionCreators(typeMessages, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Temperature)



// WEBPACK FOOTER //
// ./src/boards/mochileros/Temperature.js